/* eslint import/prefer-default-export: off */

enum keys {
  ADDRESS1 = 'Address1',
  CID = 'CID',
  CITY = 'City',
  ClientID = 'clientId',
  GCLID = 'gclid',
  LEAD_BUYER_ID = 'LeadBuyerID',
  LEAD_ID = 'leadid_token',
  LEADSOURCE = 'LeadSource',
  LEADSOURCE2 = 'LeadSource2',
  LEADVENDOR = 'LeadVendor',
  PATH_LABEL = 'PathLabel',
  POSTAL_CODE_OR_ZIP = 'PostalCodeOrZip',
  SCHOOL_ID = 'SID',
  RELAX_VAL = 'relax_val',
  TCPA_CONSENT = 'TCPAConsent',
  UTM_ADGROUP = 'utm_adgroup',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_MEDIUM = 'utm_medium',
  UTM_SOURCE = 'utm_source',
  UTM_TERM = 'utm_term',
  VENDOR = 'Vendor',
  VENDOR_LEAD_ID = 'VendorLeadID',
}

enum values {
  LEADSOURCE2_CONFIRMATION_NEW = 'shownReadyConfirmationPage',
  LEADSOURCE2_CONFIRMATION_OLD = 'shownDefaultConfirmationPage',
  LEADSOURCE_EDU = 'EDU',
  LEADSOURCE_INITIAL = 'EDU',
  LEADSOURCE_QUIZ = 'EDU-QUIZ',
}

export { keys, values }
